import { render, staticRenderFns } from "./DashboardWidgetFilter.vue?vue&type=template&id=4115a67c&"
import script from "./DashboardWidgetFilter.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetFilter.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetFilter.vue?vue&type=style&index=0&id=4115a67c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports